import React, { FormEvent, useRef } from "react";

export interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  children: React.ReactNode;
  className?: string;

  onSubmit?: (e: FormEvent<HTMLFormElement>) => void;
}

export const Form: React.FC<FormProps> = ({ children, className = "", onSubmit, ...props }) => {
  const formRef = useRef<HTMLFormElement>(null);

  return (
    <form
      ref={formRef}
      onSubmit={onSubmit}
      className={`space-y-4 ${className || ""}`}
      {...props}
    >
      {children}
    </form>
  );
};

export interface FormGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const FormGroup: React.FC<FormGroupProps> = ({ children, className = '', ...props }) => {
  return (
    <div className={`mb-3 ${className}`} {...props}>
      {children}
    </div>
  );
};
